import React from 'react';
import { useSelector } from 'react-redux';
import { ICONS } from 'Components/utils/icon/icons';
import { getDepartureDate, getTripDuration } from 'Store/trip-criteria/tripCriteria.selector';
import { ProductIntroduction } from 'Components/widgets/product-introduction/ProductIntroduction';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { InfoBannerContainer } from 'Components/widgets/info-banner/InfoBannerContainer';
type Props = {
  config: CMSContent;
  hasSeasonButton: boolean;
  hasTripadvisorButton: boolean;
  imageSrc: string;
  id: string;
  resort: Product;
  toSummerLabel: string;
  toWinterLabel: string;
};
export const ProductIntroductionLine = ({
  config,
  hasSeasonButton,
  hasTripadvisorButton,
  id,
  imageSrc,
  resort,
}: Props) => {
  const departureDate = useSelector<string>(getDepartureDate);
  const duration = useSelector<number>(getTripDuration);

  if (!config || !resort) {
    return null;
  }

  const {
    descriptionTitle,
    description,
    destination: { country },
    icon,
    id: productId,
    images = [],
    isDoubleSeason,
    isExclusiveCollection,
    isWinter,
    linkedResort,
    name,
    tripadvisor: { rating = '', ratingImageUrl = '' },
  } = resort;
  const {
    common: { loadLess, viewMore },
    resort: {
      resortIntroduction: { toSummerLabel, toWinterLabel },
    },
  } = config;
  const productIntroductionProps = {
    iconName: icon,
    imageSrc: imageSrc || images[2] || images[1] || images[0],
    productCountry: country,
    productName: name,
    ratingImage: hasTripadvisorButton
      ? {
          alt: `Tripadvisor: ${rating}`,
          src: ratingImageUrl,
        }
      : null,
    reduceLabel: loadLess,
    seasonLink:
      isDoubleSeason || !hasSeasonButton
        ? null
        : {
            iconName: isWinter ? ICONS.SUN : ICONS.MOUNTAIN,
            label: isWinter ? toSummerLabel : toWinterLabel,
            url: linkedResort && linkedResort.href,
          },
    seeMoreLabel: viewMore,
    title: descriptionTitle,
    text: description,
    isExclusiveCollection,
  };
  return (
    <SiteContainer className="Line pt-1" data-testid="resort-introduction" id={id} size="large">
      <InfoBannerContainer
        className="z-1 pb-20 pt-40 lg:pb-40 lg:pt-20"
        contentClassName="justify-center"
        departureDate={departureDate}
        duration={duration}
        popinPosition="center"
        productId={productId}
      />
      <ProductIntroduction {...productIntroductionProps} />
    </SiteContainer>
  );
};
